<div class="fn-input-box">
  @switch (type) {
    @case (inputTypeMap.PASSWORD) {
      <ng-container *ngTemplateOutlet="PASSWORD"></ng-container>
    }
    @case (inputTypeMap.TEXT || inputTypeMap.STRING) {
      <ng-container *ngTemplateOutlet=" TEXT"></ng-container>
    }
    <!-- <ng-container *ngSwitchCase="inputTypeMap.STRING">
    <ng-container *ngTemplateOutlet="TEXT"> </ng-container>
  </ng-container> -->
  @case (inputTypeMap.NUMBER) {
    <ng-container *ngTemplateOutlet="NUMBER"></ng-container>
  }
  @case (inputTypeMap.DOUBLE || inputTypeMap.FLOAT) {
    <ng-container *ngTemplateOutlet="FLOAT"></ng-container>
  }
  <!-- <ng-container *ngSwitchCase="inputTypeMap.FLOAT">
  <ng-container *ngTemplateOutlet="FLOAT"> </ng-container>
</ng-container> -->
@case (inputTypeMap.CURRENCY) {
  <ng-container *ngTemplateOutlet="CURRENCY"></ng-container>
}
@case (inputTypeMap.EMAIL) {
  <ng-container *ngTemplateOutlet="EMAIL"></ng-container>
}
@case (inputTypeMap.BOOL) {
  <ng-container *ngTemplateOutlet="BOOL"></ng-container>
}
@case (inputTypeMap.TEXTAREA) {
  <ng-container *ngTemplateOutlet="TEXTAREA"></ng-container>
}
@case (inputTypeMap.TEMPERATURE) {
  <ng-container *ngTemplateOutlet="TEMPERATURE"></ng-container>
}
@default {
  <ng-container *ngTemplateOutlet="TEXT"></ng-container>
}
}

<ng-template #TEXT>
  <input autocomplete="off" [id]="id" type="text" class="form-control fn-input" [name]="name" [placeholder]="placeholder | fnTranslate" [(ngModel)]="value" [disabled]="isDisabled" [style.text-align]="textAlign" (change)="childChange($event)" (keyup)="keyupEvent.emit(value)" (blur)="blurEvent.emit(value)" [tabindex]="tabindex" [maxLength]="maxLength" />
</ng-template>

<ng-template #PASSWORD>
  <span class="password-view">
    <input autocomplete="off" [id]="id" [type]="showPassword ? 'text' : 'password'" class="form-control fn-input" [name]="name" [placeholder]="placeholder" [(ngModel)]="value" [disabled]="isDisabled" [style.text-align]="textAlign" [tabindex]="tabindex" (keydown)="handleKeyDown($event)" (change)="childChange($event)" />
    <i class="blue cursor-pointer" (click)="showPassword = !showPassword" [ngClass]="showPassword ? 'fn-global-view' : 'fn-global-hide-password'"></i>
  </span>
</ng-template>

<ng-template #NUMBER>
  <input autocomplete="off" [isNegative]="isNegative" [id]="id" type="text" class="form-control fn-input" [name]="name" [placeholder]="placeholder" [(ngModel)]="value" fnNumberDirective [maxLength]="maxLength" [preZero]="preZero" [disabled]="isDisabled" [style.text-align]="textAlign" (blur)="blurEvent.emit(value)" [tabindex]="tabindex" (change)="childChange($event)"
    (keyup)="keyupEvent.emit(value)" />
  </ng-template>
  <ng-template #FLOAT>
    <input autocomplete="off" [isNegative]="isNegative" [id]="id" type="text" class="form-control fn-input" [name]="name" [isNotIncludeMinus]="isNotIncludeMinus" [placeholder]="placeholder" [(ngModel)]="value" fnNumberDirective [maxLength]="maxLength" [isDecimal]="'true'" [disabled]="isDisabled" [beforeDecimal]="beforeDecimal" [afterDecimal]="afterDecimal" [style.text-align]="textAlign"
      [tabindex]="tabindex" (blur)="blurEvent.emit(value)" (change)="childChange($event)" (keyup)="keyupEvent.emit(value)" />
    </ng-template>

    <ng-template #CURRENCY>
      <input autocomplete="off" [id]="id" type="text" class="form-control fn-input" [name]="name" [placeholder]="placeholder" [(ngModel)]="value" fnCurrencyDirective [maxLength]="maxLength" [beforeDecimal]="beforeDecimal" [afterDecimal]="afterDecimal" [disabled]="isDisabled" [format]="format" [style.text-align]="textAlign" [tabindex]="tabindex" (change)="childChange($event)"
        (keyup)="keyupEvent.emit(value)" />
      </ng-template>
      <ng-template #EMAIL>
        <input autocomplete="off" [id]="id" type="text" class="form-control fn-input" [name]="name" [placeholder]="placeholder" autocomplete="off" [(ngModel)]="value" [disabled]="isDisabled" [style.text-align]="textAlign" [tabindex]="tabindex" (change)="childChange($event)" (keyup)="keyupEvent.emit(value)" (input)="restrictSpace($event)" />
      </ng-template>

      <ng-template #TEXTAREA>
        <textarea [id]="id" type="text" class="form-control fn-input" [name]="name" [placeholder]="placeholder | fnTranslate" [(ngModel)]="value" [disabled]="isDisabled" [style.text-align]="textAlign" (change)="childChange($event)" (keyup)="keyupEvent.emit(value)"></textarea>
      </ng-template>

      <ng-template #BOOL>
        <!--  Need to be design -->
        <span class="fn-control custom-checkbox">
          <input autocomplete="off" [id]="id" type="checkbox" class="form-control fn-control-input fn-input" [name]="name" [placeholder]="placeholder" [(ngModel)]="value" fnNumberDirective [isDecimal]="'true'" [disabled]="isDisabled">
          <label class="fn-control-label"></label>
        </span>
      </ng-template>

      <ng-template #TEMPERATURE>
        <!--  Need to be design -->
        <div class="input-group">
          <input autocomplete="off" [id]="id" type="text" class="form-control fn-input" [name]="name" [placeholder]="placeholder" [(ngModel)]="value" fnTemperatureDirective [maxLength]="maxLength" [isNotIncludeMinus]="isNotIncludeMinus" [beforeDecimal]="beforeDecimal" [afterDecimal]="afterDecimal" [disabled]="isDisabled" [style.text-align]="textAlign" [tabindex]="tabindex"
            (change)="childChange($event)" (keyup)="keyupEvent.emit(value)" />
            <div class="input-group-append" style="height: 34px;">
              <span class="input-group-text text-uppercase">&deg; {{format}}</span>
            </div>
          </div>
        </ng-template>

        <!-- <ng-template #PHONENUMBER></ng-template>
        <ng-template #LOOKUP></ng-template>
        <ng-template #MULTILOOKUP></ng-template> -->

        @if (isErrorBox && parentForm) {
          <fn-input-error [position]="'bottom'" [submitted]="parentForm.submitted" [control]="parentForm.form.controls[name]">
          </fn-input-error>
        }

      </div>
